import script from "./PlayoutItemV2.vue?vue&type=script&setup=true&lang=js"
export * from "./PlayoutItemV2.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__